const __WEBPACK_NAMESPACE_OBJECT__ = globalThis.__import_unsupported('fs');